
export interface JobCard {
    jobId : string,
    timestamp : string | number,
    table: string  // "A1", "B2", "C3", ...
    newTable?  : string,   // use for move table
    type : 'job_card',  // wallet | job_card
    orderType: 'dine_in' | 'take_away' | 'delivery' | 'online' | 'pre_order',    
    action: JobAction,
    items: Array<JobItem>  //[JobA] //array <JobA>
     comments? : string
    guests? : number
    value? : number  // มูลค่า subitem, deposit, discount, payment
    print? : true
  
    paid? : true
    employee?: {
        id: string,
        name: string
    }
    // ลูกค้าสั่งเองจากมือถือ
    user?: {
        id: string,
        name: string
    }
    deviceId?: string
    storeId?: string
    computerUuid?: string | null // id เครื่องที่สร้างอัตโนมัติ (localStorage "computerUuid")
    // ADD จาก POS (cart.ts) = computerUuid ของเครื่องที่สร้าง ใช้นับ live.deviceIds ใน stores/{storeId}
    // (field เพิ่มเฉย ๆ JobChainV2 ไม่ได้อ่าน) job รุ่นเก่าอาจไม่มี
    computerId?: string | null
    computerName?: string | null // ชื่อเครื่อง (computerRemark_{storeId}) ต่อท้าย key ใน live.deviceIds
    sync?: string | null // time of sync
    nonce? : any
}

export enum JobAction {
    OPEN = "OPEN",   
    DRAWER = "DRAWER",

    //status table
    QR_CODE_ORDER = "QR_CODE_ORDER",
    LOCK_TABLE = "LOCK_TABLE",
    PRINT_PREVIEW = "PRINT_PREVIEW",
    SET_START_TIME = "SET_START_TIME",
    SET_GUESTS = "SET_GUESTS",
    CHANGE_SHIFT = "CHANGE_SHIFT",

    // items
    ADD = "ADD",
    MOVE = "MOVE",
    SPLIT_ITEM = "SPLIT_ITEM",
    SPLIT_BILL = "SPLIT_BILL",
    SET_PRICE = 'SET_PRICE',
    SET_DISCOUNT = 'SET_DISCOUNT',
    SET_DISCOUNT_ENT  = 'SET_DISCOUNT_ENT',
    SET_COMMENT = 'SET_COMMENT',
    OPEN_MENU = 'OPEN_MENU',
    VOID = "VOID",  //void_items
    PAY = "PAY",
    REPRINT = "REPRINT",


    // receipt
    VOID_RECEIPT = "VOID_RECEIPT",

    //shop
    CLOSE = "CLOSE",
}


export enum JobItemStatus {
    ACTIVE=  'active',
    VOIDED  = 'voided',
    MOVED = 'moved',
    PAID = 'paid'
}

export interface JobItem {
    uuid: string
    productId?: string
    qty?: number
    price?: number
     comments?: string
    options?: Array<JobItem>
    discount?: [mode: number, value: number]//
    table? : string | Array<string>
    status?: 'void' | 'paid' | 'moved' | 'active'

    jobId : string
    timestamp : string
    // computed

}

export enum ErrorMessage {
    DISCOUNT_INVALID = 'การให้ส่วนลดต้องไม่เกิน 100%',
    DISCOUNT_VALIDATE_INPUT = 'กรุณากรอกส่วนลด',
    VAT_VALIDATE_INPUT = 'กรุณากรอก TAX',
    VALIDATE_PRICE = 'กรุณากรอกราคา'
}

